// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const READ_WHOLE_REVIEW = "\u010cti cel\u00e9...";
export const REVIEW_OF_ALIKE_MODEL_stroller = "Recenze souvisej\u00edc\u00edho modelu %(stroller)s";
export const REVIEW_VERIFIED = "Ov\u011b\u0159en\u00e1 recenze";
export const STROLLERS_DETAILED_REVIEW = "Podrobn\u00e1 recenze";
export const STROLLERS_NOT_APPROVED = "\u010dek\u00e1 na kontrolu";
